import { useLocation, useNavigate } from "react-router-dom";
import PPAPReport from "@/pages/PPAPReport";
import QMSRCrosswalk from "@/pages/QMSRCrosswalk";

function Tab({ label, path, testId, active, onClick }) {
  return (
    <button
      type="button"
      onClick={() => onClick(path)}
      data-testid={testId}
      className={
        "px-4 py-2 text-[13px] font-medium border-b-2 -mb-px transition-colors " +
        (active
          ? "border-[color:var(--mos-accent)] text-slate-900"
          : "border-transparent text-slate-500 hover:text-slate-800")
      }
    >
      {label}
    </button>
  );
}

/**
 * Quality hub · two sub-tabs, both routed:
 *   /quality              → PPAP Completeness Report
 *   /quality/crosswalk    → QMSR Readiness Crosswalk
 */
export default function Quality() {
  const location = useLocation();
  const navigate = useNavigate();
  const isCrosswalk = location.pathname.endsWith("/crosswalk");

  return (
    <div data-testid="page-quality" className="space-y-6">
      <div
        className="border-b flex items-center gap-1"
        style={{ borderColor: "var(--mos-border)" }}
      >
        <Tab
          label="PPAP Completeness Reports"
          path="/quality"
          testId="tab-ppap"
          active={!isCrosswalk}
          onClick={navigate}
        />
        <Tab
          label="QMSR Readiness Crosswalk"
          path="/quality/crosswalk"
          testId="tab-crosswalk"
          active={isCrosswalk}
          onClick={navigate}
        />
      </div>

      {isCrosswalk ? <QMSRCrosswalk /> : <PPAPReport />}
    </div>
  );
}
